exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swiper-slide[data-v-ec888668] {\n  height: auto;\n}\n.trusted-link[data-v-ec888668] {\n  color: #000;\n}\n", ""]);

// exports
